import _ from 'lodash';
import NextHead from 'next/head';
import { BranchConstants } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Head = function Head(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === void 0 ? '' : _ref$subtitle,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children;
  var favicon = BranchConstants.FAVICON_PATH;
  var branch = BranchConstants.HEAD_TITLE;

  var titleText = _.compact([branch, title, subtitle]).join('-');

  return /*#__PURE__*/_jsxs(NextHead, {
    e2eid: "components_Head_NextHead",
    children: [/*#__PURE__*/_jsx("link", {
      rel: "shortcut icon",
      href: favicon,
      e2eid: "components_Head_link"
    }), /*#__PURE__*/_jsx("title", {
      e2eid: "components_Head_title",
      children: titleText
    }), /*#__PURE__*/_jsx("meta", {
      name: "title",
      content: titleText,
      e2eid: "components_Head_meta"
    }), /*#__PURE__*/_jsx("meta", {
      name: "description",
      content: "\u521D\u65E5\u8A3A\u6240\u5F8C\u53F0",
      e2eid: "components_Head_meta_4"
    }), /*#__PURE__*/_jsx("meta", {
      name: "keywords",
      content: "\u521D\u65E5\uFF0C\u8A3A\u6240\u6E1B\u91CD",
      e2eid: "components_Head_meta_5"
    }), /*#__PURE__*/_jsx("meta", {
      name: "robots",
      content: "index, nofollow",
      e2eid: "components_Head_meta_6"
    }), /*#__PURE__*/_jsx("meta", {
      httpEquiv: "Content-Type",
      content: "text/html; charset=utf-8",
      e2eid: "components_Head_meta_7"
    }), children]
  });
};

export default Head;